import React, {useState, useEffect} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { resetAccessToPaymentStatusPage } from "../store/navigationSlice";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import "../styles/PaymentStatus.css";
import crossMark from "../assets/cross_mark.svg";
const PaymentFailurePage = () => {

    const navigate = useNavigate();
    const [countdown, setCountdown] = useState(10); // 10 seconds countdown
    const dispatch = useDispatch();
    const canAccessPaymentStatusPage = useSelector((state) => state.navigation.canAccessPaymentStatusPage);
    const location = useLocation();
    const errorMessage = location.state?.errorMessage;

    useEffect(() => {
        return () => {
          dispatch(resetAccessToPaymentStatusPage()); // cleanup
        };
    }, [dispatch]);


    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown(prevCountdown => {
                if (prevCountdown <= 1) {
                    clearInterval(timer);
                    navigate('/plans-and-pricing');
                    return 0;
                }
                return prevCountdown - 1;
            });
        }, 1000); // Update every second

        return () => clearInterval(timer); // Cleanup the timer on component unmount
    }, []);

    if (!canAccessPaymentStatusPage) {
        return <Navigate to="/plans-and-pricing" replace />;
    }

    return (
        <div className="payment-failure-message">
            <img className='payment-tick-icon' src = {crossMark}/>
            <p className='fw700 fs26'>Payment Failed!</p>
            <p className='fs20'>{errorMessage}</p>
            <p className='fs20'>You will be redirected to the plans and pricing page in {countdown} seconds...</p>
        </div>
    );
};

export default PaymentFailurePage;